<template>
    <div class="main-card mb-3 card">
        <a :href="`/products/${product.slug}`">
            <div style="min-height: 176px; overflow: hidden; object-fit: contain">
                <img :src="productImage"
                     alt=""
                     width="100%"
                >
            </div>
        </a>
        <div class="card-body text-center">
            <a class="text-decoration-none" :href="`/products/${product.slug}`">
                <h5 class="card-title" style="height: 30px; overflow: hidden">
                    {{ product.name }}
                </h5>
            </a>
            <h6 class="card-subtitle">
                <template v-if="Boolean(Number(product.default_discount))">
                    <del class="text-danger"><i class="icofont-taka"></i>{{ product.sell_price }}</del>
                    <i class="icofont-taka"></i>{{ Number(product.sell_price) - Number(product.default_discount) }}
                </template>
                <template v-else>
                    <i class="icofont-taka"></i>{{ product.sell_price }}
                </template>
            </h6>
            <button class="btn btn-danger btn-block" @click="addToCart" :disabled="loading || isInCart(product.id)">
                ADD TO CART
            </button>
        </div>
    </div>
</template>

<script>
    import {optional} from "../app/Helpers/Helpers";

    export default {
        name: "Product",
        props: {
            product: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                loading: false
            }
        },
        methods: {
            addToCart() {
                this.loading = true;
                window
                    .axios
                    .post(`/api/carts/${this.product.slug}`)
                    .then(response => {
                        this.$store.dispatch('getCarts');
                    }).finally(() => {
                    this.loading = false;
                })
            }
        },
        computed: {
            productImage() {
                return Boolean(optional(this.product, 'image', 'path')) ?
                    optional(this.product, 'image', 'path') :
                    '/images/no_image.jpg';
            },
            isInCart() {
                return (product_id) => this.$store.getters.isInCart(product_id);
            }
        }
    }
</script>

<style scoped>

</style>